export default __webpack_public_path__ + "static/img-art-pandas-profiling-3-2d935df45f0514440880493c3fd9d23d.webp";